"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.query = void 0;
var query = "\n  query {\n    allFishermanBusinessWebsitePage(sort: { order: ASC, fields: navigationPriority }) {\n      nodes {\n        title\n        slug\n        pageType\n        url\n        navigationPriority\n        groupName\n        props\n        _id\n      }\n    }\n  }\n";
exports.query = query;